module.exports = "<form #searchForm=\"ngForm\" (ngSubmit)=\"search()\"\n  class=\"search-box\">\n  <input type=\"text\" class=\"form-control\"\n    [(ngModel)]=\"query\" name=\"query\"\n    placeholder=\"{{ 'Search shop' | translate | async }}\">\n  <button type=\"submit\">\n    <i class=\"material-icons search\"></i>\n  </button>\n</form><!-- form.search-box -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/product.search.html
// module id = ./src/app/Templates/product.search.html
// module chunks = main